<template>
  <div v-bem="{rtl: $i18n.locale === 'ar'}" class="container">
    <gallery :images="images" :index="index" @close="index = null"></gallery>
    <div class="row">
      <div
        v-bem:item
        class="col-4 col-t-6"
        v-for="(image, imageIndex) in images"
        :key="imageIndex"
      >
        <div class="img" @click="index = imageIndex" :style="{ backgroundImage: `url(${image})` }">
          <span>+</span>
        </div>
      </div>
      <p class="notice">{{$t('notices.images')}}</p>
    </div>
  </div>
</template>

<script>
import VueGallery from 'vue-gallery'

export default {
  props: ['step'],
  name: 'Gallery',
  components: {
    'gallery': VueGallery
  },
  data: () => ({
    index: null
  }),
  computed: {
    images() {
      const model = this.$store.state.models.find(model => model.id_simulateur_modele === this.$store.state.selected.model).nom_lien;
      let photos = [...Array(6)].map((_, index) => `https://www.succursalesrenault.ma/onlinestore/visuels/${model}/${index+1}.jpg`);
      if (this.step === 3) {
        photos = photos.slice(0, 3);
      } else {
        photos = photos.slice(3, 6);
      }
      return photos;
    }
  }
}
</script>

<style scoped lang="scss">
.gallery {
  max-width: rem(1000);
  margin: 0 auto;
  &__item {
    text-align: center;
    padding: 0 rem(5);
  }
  .img {
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: rem(1) solid $dark;
    height: rem(200);
    margin: rem(5);
    cursor: pointer;
    span {
      @extend %transform-center;
      @include font-size(32);
      font-family: var(--primary-font);
      line-height: 0.8;
      color: $white;
      background-color: rgba(var(--primary-color), 1);
      padding: 0 rem(5);
      opacity: 0;
      height: rem(30);
      transition: opacity 0.4s;
    }
    &:hover {
      span {
        opacity: 1;
      }
    }
  }
  &--rtl {
    .img {
      span {
        line-height: 1.2;
      }
    }
  }
  .notice {
    padding: rem(10);
    color: $dark-gray;
    @include font-size;
    text-align: center;
  }
}
</style>
